'use client';
import {getCssVar} from '@web-libs/features/colors/application/colors';
import {CSSProperties} from 'react';
import {Headline} from '@web-libs/ui/ui-components/typo/headline';
import {Tabs} from '@web-libs/features/appointments/ui/booking/tabs/tabs';
import {useBookingSearch} from '@web-libs/features/appointments/application/booking/use-booking-search';
import {CategoryItem} from '@web-libs/features/appointments/ui/booking/category-item';
import {SimpleLoader} from '@web-libs/ui/ui-components/loader/loader.component';
import cssStyles from './booking-page.module.css';
import {useDictionaryContext} from '@web-libs/core/internationalization/dictionary.context';
import {Button} from '@web-libs/ui/ui-components/buttons/button';
import {useTageaRouter} from '@web-libs/core/routing/application/use-tagea-router.concern';
import {routes} from '@web-app/[lang]/[tenant]/[institution]/routes-institution';

export type BookingView = {
    style?: CSSProperties
}

export const BookingView = (props: BookingView) => {
    const _style: CSSProperties = {
        borderRadius: 30,
        backgroundColor: getCssVar('light'),
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
        ...props.style
    };

    const {
        specializations,
        currentSpecialization,
        categories,
        setCurrentSpecialization,
        isLoadingSpecializations,
        isLoadingCategories,
        specializationError,
        categoryError,
        openNoCategorySelection
    } = useBookingSearch();

    const dict = useDictionaryContext();
    const openNoCategorySelectionFunction = () => {
        openNoCategorySelection();
    };
    const router = useTageaRouter();

    function navigateToAllCategories() {
        router.push(routes.appointmentBookingCategory('allCategories',
                                                      currentSpecialization?.id));
    }

    return (
        <div style={{..._style}}>
            <div style={{
                height: 96,
                flexShrink: 0,
                borderBottom: '2px solid ' + getCssVar('lightShade'),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Headline size={'md'}>{dict.appointments.bookableAppointment_title}</Headline>
            </div>
            <div className={cssStyles.bookingViewInner} style={{overflowY: 'auto', display: 'flex', flexDirection: 'column'}}>
                <SimpleLoader error={specializationError} loading={isLoadingSpecializations}>
                    <>
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                            <div style={{display: 'flex'}}>
                                <Tabs specializations={specializations} activeSpecialization={currentSpecialization!}
                                      onSpecializationSelected={(spec) => {
                                          setCurrentSpecialization(spec);
                                      }}/>
                            </div>
                            <Button style={{alignSelf: 'center'}} onClick={openNoCategorySelectionFunction}
                                    text={dict.appointments.noSelection}></Button>
                        </div>
                        <div style={{marginTop: 48}}>
                            <SimpleLoader error={categoryError} loading={isLoadingCategories}>
                                {categories.length != 0 ? categories.map(category => {
                                    return (
                                        <CategoryItem specId={currentSpecialization?.id} style={{marginBottom: 16}} category={category}
                                                      key={category.id}/>
                                    );
                                }) : <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 16, flexDirection: 'column'}}>
                                    <h3>Keine Kategorien gefunden</h3>
                                    <Button color={'primary'} onClick={navigateToAllCategories} text={'Alle anzeigen'}></Button>
                                </div>}
                            </SimpleLoader>
                        </div>
                    </>
                </SimpleLoader>
            </div>
        </div>
    );
};
